import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Location: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-4.97 0-9.62-2.46-12.41-6.58-112.77-166.16-167.59-279.5-167.59-346.49 0-103.07 80.75-186.93 180-186.93s180 83.86 180 186.93c0 67-54.82 180.34-167.59 346.49-2.79 4.11-7.44 6.58-12.41 6.58zm0-510c-82.71 0-150 70.4-150 156.93 0 29.2 13.37 71.4 39.73 125.42 24.96 51.14 62.02 113.58 110.27 185.8 48.25-72.22 85.31-134.66 110.27-185.8 26.36-54.02 39.73-96.21 39.73-125.42 0-86.53-67.29-156.93-150-156.93z' />
    <path d='m390.11 390c-49.57 0-89.89-40.33-89.89-89.89s40.33-89.89 89.89-89.89 89.89 40.33 89.89 89.89-40.33 89.89-89.89 89.89zm0-149.79c-33.03 0-59.89 26.87-59.89 59.89s26.87 59.89 59.89 59.89 59.89-26.87 59.89-59.89-26.87-59.89-59.89-59.89z' />
    <path d='m335 660h-215v-30h185c16.57 0 30 13.43 30 30z' />
    <path d='m445 660h215s0-30 0-30h-185c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Location.displayName = 'Location';

export default Location;
